import {store} from "@/store"
import moment from 'moment'
import {getAssignmentTracksAll} from "@/api/assignmentrequests";

const state = {
  tracks: [],
  groupTracks: [],
  assignments: []
}

const getters = {
  getAllTracks(state) {
    return state.tracks
  },
  getAllGroupTracks(state) {
    return state.groupTracks
  },
  getAssignments(state) {
    return state.assignments
  },
};

const mutations = {
  setTracks: (state, tracks) => {
    state.tracks = tracks
  },
  addGroupTracks: (state, {id, tracks, workId}) => {
    let data = {
      tracks: tracks,
      workId: workId,
      organizationId: id
    }
    state.groupTracks = [...state.groupTracks, data]
  },
  clearGroupTracks: (state) => {
    state.groupTracks = []
  },
  setAssignments: (state, assignments) => {
    state.assignments = assignments
  }
};

const actions = {
  actionSetAssignments({commit}, payload) {
    commit("setAssignments", payload)
  },
  async actionGetWorkTracks({commit}, payload) {
    console.log(payload)
    let subOperationId = payload
    let organizationId = store.getters["Contexts/getOrganization"]
    let date = moment(store.getters["Map/getMapDate"]).endOf("day").format("YYYY-MM-DDTHH:mm:ss")
    let result = []
    let body = {
      organizationId: organizationId,
      date: date
    }
    commit("setTracks", [])

    console.log('body', body)
    const echelonTypes = {
      '1': 'Sowing',
      '2': 'Harvesting'
    }
    if (subOperationId && !parseInt(subOperationId)) {
      body.echelonType = echelonTypes[subOperationId.split('-')[1]]
    }
    else if (subOperationId) {
      body.subOperationId = subOperationId
    }
    if (subOperationId) {
      console.log("fiifififif")
      result = await getAssignmentTracksAll(body)
      commit("setTracks", result)
    }
  },
  async actionGetWorkGroupTracks({commit}, payload) {
    let subOperationId = payload.subOperationId
    let date = moment(store.getters["Map/getMapDate"]).format("YYYY-MM-DD")
    commit("clearGroupTracks")

    if (subOperationId) {
      payload.orgIds.forEach(organizationId => {
        let body = {
          organizationId: organizationId,
          date: date
        }
        if (subOperationId && !parseInt(subOperationId)) {
          body.echelonType = subOperationId.split('-')[1]
        }
        else if (subOperationId) {
          body.subOperationId = subOperationId
        }
        getAssignmentTracksAll(body).then((data) => {
          commit("addGroupTracks", {id: organizationId, tracks: data, workId: subOperationId})
        })

      });
    }
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
